import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { CasinoPlayerActivityRequestFormatter } from "../CasinoPlayerActivityRequestFormatter";
import { CasinoPlayerActivityResponseFormatter } from "../CasinoPlayerActivityResponseFormatter";
export function createCasinoPlayerActivityConnection() {
    return createRESTConn({
        name: ConnectionNames.casinoPlayerActivity,
        handlers: {
            requestFormatter: CasinoPlayerActivityRequestFormatter,
            responseFormatter: CasinoPlayerActivityResponseFormatter
        }
    });
}
//# sourceMappingURL=CreateCasinoPlayerActivityConnection.js.map